import React, {useEffect, useState} from "react";
import "katex/dist/katex.min.css";
import Latex from 'react-latex-next';
import { formatLatexText } from '../../utils/formatLaTex';

export default function QuestionText(props) {
    const question = props.question;

    const [fontSize, setFontSize] = useState(window.innerWidth <= 500 ? "0.8em" : "0.9em");

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 500) {
                setFontSize("0.8em");
            } else {
                setFontSize("0.9em");
            }
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    function getQuestionText() {
        // Get the question text from props
        let questionText = question.text?.trim();

        if (!questionText) {
            return null;
        }

        console.log("Original questionText:", questionText);

        // Use the centralized formatLatexText utility for consistent formatting
        // This handles displaylines, align environments, HTML entities, etc.
        questionText = formatLatexText(questionText);

        console.log("Processed questionText:", questionText);
        
        return <Latex>{questionText}</Latex>;
    }

    return (
        <div
            style={{
                backgroundColor: "#FFFFFF",
                height: "100%",
                width: "100%",
                borderRadius: "5px",
                textAlign: "left",
                fontSize: fontSize,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "20px",
                whiteSpace: 'pre-wrap',
            }}
        >
            {getQuestionText()}
        </div>
    );
}
